/**
 * A duration in seconds as "2m05s", "45s" under a minute, or "7h47m" from an
 * hour on. The total is rounded to its smallest shown unit first, so 119.6s
 * reads "2m00s" and 7199s reads "2h00m", never "1m60s" or "1h60m".
 */
export const formatDuration = (seconds: number): string => {
  const total = Math.round(seconds);
  if (total >= 3600) {
    const minutes = Math.round(total / 60);
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}h${String(m).padStart(2, "0")}m`;
  }
  const m = Math.floor(total / 60);
  const s = total % 60;
  return m > 0 ? `${m}m${String(s).padStart(2, "0")}s` : `${s}s`;
};
